module.exports = __webpack_public_path__ + "static/media/demoPersona.dbc8db84.png";